const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 80,
    viewBox: "0 0 57 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#535353",
    fillRule: "nonzero",
    d: "M.36 16.508l5.122 57.091 22.983 6.148 23.047-6.031 5.128-57.208H.36zm45.626 12.997l-.32 3.705-.142 1.71h-26.96l.644 7.62h25.675l-.172 1.416-1.656 18.355-.121 1.073L28.5 67.28v-.003l-.017.007-14.426-3.756-.979-10.829h7.073l.501 5.372 7.844 1.993.004-.149v.008l7.86-1.682.822-8.716H12.764l-1.732-19.579-.17-2.008h35.293l-.169 1.568zM5.672.398h3.56v3.528h3.259V.398h3.56v10.68h-3.56V7.503H9.233v3.577h-3.56V.399zM20.734 3.94H17.6V.398h9.833V3.94h-3.137v7.139h-3.56V3.94zM28.992.398h3.713l2.284 3.753L37.271.398h3.715v10.68h-3.548V5.786L34.99 9.582h-.062l-2.45-3.797v5.294H28.99V.399h.001zm13.766 0h3.562v7.15h5.008v3.531h-8.57V.4z",
    style: {
      mixBlendMode: "luminosity"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo24);
export default __webpack_public_path__ + "static/media/logo24.c2f5bdc7913cb83cf9d709dd87afe6d4.svg";
export { ForwardRef as ReactComponent };